
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from "@/hooks/use-toast";
import { addLeague } from './league/leagueOperations';
import { extractLeagueErrorMessage } from './league/errorHandlers';

export interface LeagueMutationResult {
  addLeagueMutation: ReturnType<typeof useMutation<void, Error, string>>;
}

export const useLeagueMutations = (selectedCountry: string): LeagueMutationResult => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const addLeagueMutation = useMutation({
    mutationFn: async (name: string) => {
      await addLeague(name, selectedCountry);
    },
    onSuccess: () => {
      toast({ title: "Success", description: "League added successfully" });
      // Invalidate and refetch leagues for the selected country
      queryClient.invalidateQueries({ queryKey: ['leagues', selectedCountry] });
    },
    onError: (error) => {
      const errorMessage = extractLeagueErrorMessage(error);
      toast({ 
        title: "Error", 
        description: errorMessage, 
        variant: "destructive" 
      });
    }
  });

  return {
    addLeagueMutation
  };
};
